export default __webpack_public_path__ + "static/media/Step2-cto.4893a1d4.svg";